// extracted by mini-css-extract-plugin
module.exports = {"reviewsWithBorderContainer":"ProjectsReviews_reviewsWithBorderContainer__dlAhF"};